import React, {useState} from 'react';
import TreeView from '@material-ui/lab/TreeView';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import TreeItem from '@material-ui/lab/TreeItem';
import {makeStyles} from '@material-ui/core/styles';
import {useApiNotification} from "../../ui/ApiNotificationProvider";
import PermissionEditItem from "./PermissionEditItem";
import PermissionViewItem from "./PermissionViewItem";
import {getOrganizationUnitChildren} from "../../../api/organization-unit-functions";
import {OrganizationUnit} from "../../../models/organization";

const useStyles = makeStyles({
    root: {
        height: 'auto',
        flexGrow: 1
    },
    textField: {
        padding: '8px'
    }
});
const PermissionItem = ({
                            unit,
                            viewOnly,
                            onExpanded,
                            onChange,
                            availablePermissions,
                            permissions,
                            inheritedPermissions,
                            userPermissions
                        }: any) => {
    const classes = useStyles();
    const {handleError} = useApiNotification();
    const [childNodes, setChildNodes] = useState<OrganizationUnit[]>([]);
    const [expandedNodes, setExpandedNodes] = useState<any[]>([]);

    const onNodeToggle = async (event: any, nodeIds: any) => {
        const expanding = nodeIds.filter((id: any) => !expandedNodes.includes(id));
        setExpandedNodes(nodeIds);
        if (expanding[0]) {
            const orgUnitChildren = await loadChildren();
            onExpanded(unit, orgUnitChildren);
        }
    };

    const loadChildren = async () => {
        return await getOrganizationUnitChildren(unit.organizationId, unit.id)
            .then((orgUnitChildren) => {
                if (orgUnitChildren)
                    setChildNodes(orgUnitChildren);
                else
                    throw orgUnitChildren;
                return orgUnitChildren;
            })
            .catch(handleError);
    };

    const explicitPermissions = permissions[unit.id] ? permissions[unit.id].explicitPermissions : 0;
    const joinedUserPermissions = userPermissions[unit.id] ?
        (userPermissions[unit.id].explicitPermissions || 0) | (userPermissions[unit.id].inheritedPermissions || 0) : 0;

    const itemContent = viewOnly ?
        <PermissionViewItem unit={unit}
                            availablePermissions={availablePermissions}
                            explicitPermissions={explicitPermissions}
                            inheritedPermissions={inheritedPermissions}/> :
        <PermissionEditItem unit={unit}
                            availablePermissions={availablePermissions}
                            userPermissions={joinedUserPermissions}
                            explicitPermissions={explicitPermissions}
                            inheritedPermissions={inheritedPermissions}
                            onChange={onChange}/>;

    const children = childNodes.map(u => {
        return <PermissionItem viewOnly={viewOnly}
                               onChange={onChange}
                               onExpanded={onExpanded}
                               availablePermissions={availablePermissions} permissions={permissions}
                               inheritedPermissions={explicitPermissions | inheritedPermissions}
                               userPermissions={userPermissions}
                               key={(u as any).id.toString()}
                               unit={u}/>;
    });
    return (unit ?
        <TreeView className={classes.root}
                  defaultCollapseIcon={<ExpandMoreIcon/>}
                  defaultExpandIcon={<ChevronRightIcon/>}
                  onNodeToggle={onNodeToggle}
                  expanded={expandedNodes}>
            <TreeItem key={unit.id} nodeId={unit.id.toString()} label={itemContent}>
                {[
                    <span key='fake-node'></span>,
                    ...children
                ]}
            </TreeItem>
        </TreeView> : null);
};

export default PermissionItem;
